import { PageOptions } from './../../../../../shared/data-table/data-table.interface';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../../../../../config/config';
import { CgpApiService } from '../../../../../../modules/cgp-api';
import { getEnv } from '../../../../../../modules/utility';
import { BaseHttpService } from '../../../../../shared/base-http/base-http.service';
import { map } from 'rxjs/operators';

export interface TprChild {
   text: string;
   id: string;
   leaf: boolean;
   checked: boolean;
}

export interface TprFolder {
   text: string;
   cls: string;
   id: string;
   children: TprChild[];
}

@Injectable()
export class
   TprFilesApiService {

   constructor(private readonly cgpApiService: CgpApiService,
      private readonly baseHttpService: BaseHttpService) { }

   public getTprFiles(folderName: string, tprToolId: number, pageOptions?: PageOptions) {
      pageOptions = pageOptions || {
         page: 0,
         order: 'asc',
         size: 10,
         sort: 'partId',
      };

      return this.cgpApiService.get(`${config.tprecmApiBaseUrl[getEnv()]}tpr/file?folderName=${folderName}&tprToolId=${tprToolId}&`
         + `page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}`, null);
   }

   public uploadTprFile(tprToolId, selectedFolder, files) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/file?tprToolId=${tprToolId}&folder=${selectedFolder}`
      return this.cgpApiService.multipartPost(url, files, null)
   }

   public updateTprFile(tprToolId, action, selectedFolder, idList) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/file?tprToolId=${tprToolId}&action=${action}&folder=${selectedFolder}`;
      return this.cgpApiService.put(url, idList, null);
   }

   public deleteTprFile(tprToolId, idList) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/file?tprToolId=${tprToolId}`;
      return this.cgpApiService.deleteWithBody(url, null, idList);
   }

   public getFolders(): Observable<TprFolder[]> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/folder`;
      return this.cgpApiService.get(url, null)
         .pipe(map(data => data as TprFolder[]));
   }

   public getContacts(tprToolId: number,
      pageOptions: PageOptions =
         {
            page: 0,
            order: 'asc',
            size: 10,
            sort: 'contactType',
         }
   ) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/contact?`
         + `tprToolId=${tprToolId}&order=${pageOptions.order}&page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}`;
      return this.cgpApiService.get(url, null);
   }

   public sendNotificationEmail(toolNo: string, folder: string, emailList: string) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/email`;
      return this.cgpApiService.post(url, { toolNo, folder, emailList }, null);
   }
}
